import { ReactNode } from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useViewportDevice } from '@zep/react';
import { Button } from '@zep/ui';
import S from './Empty.module.scss';
const Empty = (props: EmptyProps) => {
  const {
    image,
    emptyItem,
    description,
    ctaText,
    onClickCTA,
    useCustomMessage
  } = props;
  const {
    locale
  } = useRouter();
  const {
    isMobile,
    isTablet
  } = useViewportDevice();
  const {
    t
  } = useTranslation(['common'], {
    useSuspense: true
  });
  const isString = typeof emptyItem === 'string';
  const HtmlRegex = /<\/?[a-z][\s\S]*>/;
  const isHtml = isString && !!emptyItem.match(HtmlRegex);

  // 한글일 경우 받침 유무 판단하여 조사 추가
  const postPosition = locale === 'ko' && isString ? emptyItem.hasBatchim() ? '이' : '가' : '';
  const buttonSize = isMobile ? 'xs' : isTablet ? 'sm' : 'md';
  return <div className={S.container} data-sentry-component="Empty" data-sentry-source-file="Empty.tsx">
      <img width={image?.width ? image.width : 64} height={image?.height ? image.height : 43} src={image?.url || '/images/light/common/speech_bubble-gray100.svg'} alt="empty-icon" />
      <div className={S.text_container}>
        <div className={classNames(S.empty_text, description && S.multi_line)}>
          {isString ? useCustomMessage ? isHtml ? <span dangerouslySetInnerHTML={{
          __html: emptyItem
        }} /> : emptyItem : t('common:emptyItem', {
          item: emptyItem + postPosition
        }) : emptyItem}
        </div>
        {description && !!description.match(HtmlRegex) ? <div className={S.empty_description} dangerouslySetInnerHTML={{
        __html: description
      }} /> : <div className={S.empty_description}>{description}</div>}
      </div>
      {ctaText && <div className={S.cta_wrapper}>
          <Button size={buttonSize} variant="primary" onClick={onClickCTA}>
            {ctaText}
          </Button>
        </div>}
    </div>;
};
export default Empty;
type EmptyProps = {
  image?: {
    url: string;
    width?: number;
    height?: number;
  };
  emptyItem: string | ReactNode;
  description?: string;
  ctaText?: string;
  onClickCTA?: () => void;
  /**
   * true 일때 "이 없습니다." 표시하지 않음
   */
  useCustomMessage?: boolean;
};